import { styled } from '@linaria/react';

export const NewUserTooltipWrapper = styled.div<{
  orientation?: 'left' | 'right';
}>`
  width: 218px;
  height: 72px;
  color: #fff;
  position: absolute;
  transform: translateY(-50%);
  z-index: calc(var(--cxy-z-index-control-high));
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: auto;
  transition: opacity 0.1s ease-in;
`;

export const TextWrapper = styled.div<{
  orientation?: 'left' | 'right';
}>`
  position: absolute;
  left: ${({ orientation }) => (orientation === 'left' ? '12px' : '6px')};
  padding: ${({ orientation }) => (orientation === 'left' ? '16px' : '6px 30px 10px 12px')};
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Public Sans';
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  text-align: start;
`;

export const CloseIconWrapper = styled.div<{
  isMobile?: boolean;
  orientation?: 'left' | 'right';
}>`
  position: absolute;
  top: ${({ isMobile }) => (isMobile ? '8px' : '12px')};
  right: ${({ orientation }) => (orientation === 'right' ? '18px' : '10px')};
  width: 16px;
  height: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;
